// src/components/CommercialCvAo.jsx — LE COMMERCIAL IMPRIMÉ SUR LES CV DU
// DOSSIER AO (30.10 : « le commercial par défaut qui sera mis sur les CV
// format entreprise »). Le pied d'un CV format entreprise porte un contact
// commercial de la liste « Contacts commerciaux CV » (Configuration) ; le
// dossier choisit le sien, sinon le premier de la liste. Tout est servi :
// GET / PUT /ao/:id/commercial-cv — l'écran ne devine rien.
import React, { useCallback, useEffect, useState } from 'react';
import APIService from '../services/api';

const BASE = 'https://besoins-tat-production.up.railway.app';
const authH = () => ({ Authorization: `Bearer ${APIService.getToken()}` });

export default function CommercialCvAo({ aoId, showNotification }) {
  const [etat, setEtat] = useState(null);     // null = lecture, false = route absente
  const [busy, setBusy] = useState(false);

  const charger = useCallback(async () => {
    try {
      const r = await fetch(`${BASE}/ao/${aoId}/commercial-cv`, { headers: authH() });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || j.success === false) { setEtat(false); return; }
      setEtat(j);
    } catch { setEtat(false); }
  }, [aoId]);
  useEffect(() => { charger(); }, [charger]);

  // Route absente (serveur pas encore livré) ou liste vide : rien à choisir.
  if (!etat || !(etat.contacts || []).length) return null;

  const choisir = async (nom) => {
    setBusy(true);
    try {
      const r = await fetch(`${BASE}/ao/${aoId}/commercial-cv`, {
        method: 'PUT', headers: { ...authH(), 'Content-Type': 'application/json' }, body: JSON.stringify({ nom }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || j.success === false) throw new Error(j.error || `Refusé (${r.status}).`);
      showNotification?.(j.message, 'success');
      await charger();
    } catch (e) { showNotification?.(e.message, 'error'); }
    finally { setBusy(false); }
  };

  // Le défaut de l'ORGANISATION (réglé par un administrateur, sinon le
  // premier de la liste) — servi par le serveur.
  const defaut = etat.defaut?.nom || etat.contacts[0]?.nom;
  const u = APIService.getCurrentUser();
  const admin = u?.admin === true || u?.role === 'admin' || u?.super_admin === true;
  const faireDefaut = async () => {
    setBusy(true);
    try {
      const r = await fetch(`${BASE}/ao/commercial-cv-defaut`, {
        method: 'PUT', headers: { ...authH(), 'Content-Type': 'application/json' }, body: JSON.stringify({ nom: etat.commercial?.nom }),
      });
      const j = await r.json().catch(() => ({}));
      if ([404, 405, 501].includes(r.status) && (!j.error || /route non trouv/i.test(j.error))) throw new Error('Le commercial par défaut de l’organisation arrive côté serveur.');
      if (!r.ok || j.success === false) throw new Error(j.error || `Refusé (${r.status}).`);
      showNotification?.(j.message, 'success');
      await charger();
    } catch (e) { showNotification?.(e.message, 'error'); }
    finally { setBusy(false); }
  };
  const valeur = etat.par_defaut ? '' : (etat.commercial?.nom || '');
  return (
    <label title="Le contact commercial imprimé en pied des CV format entreprise générés depuis ce dossier"
      style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: 'var(--erp-text-secondary)' }}>
      <i className={`bi bi-${busy ? 'arrow-repeat' : 'person-badge'}`} aria-hidden="true" />
      Commercial sur les CV
      <select className="erp-field" value={valeur} disabled={busy} onChange={e => choisir(e.target.value)}
        style={{ fontSize: '12px', padding: '4px 8px', maxWidth: '220px' }}>
        <option value="">{defaut ? `Par défaut (${defaut})` : 'Par défaut'}</option>
        {etat.contacts.map(c => <option key={c.nom} value={c.nom}>{c.nom}</option>)}
      </select>
      {admin && !etat.par_defaut && etat.commercial?.nom && etat.commercial.nom !== defaut && (
        <button type="button" className="tuto-bulle__lien" onClick={faireDefaut} disabled={busy}
          title="Ce contact signera aussi les CV des autres dossiers sans choix, et ceux produits depuis une fiche ou un besoin">
          En faire le défaut de l’organisation
        </button>
      )}
      {etat.absent_de_la_liste && (
        <span style={{ color: 'var(--erp-warning)' }} title="Le contact choisi n'est plus dans la liste : le défaut est utilisé">
          <i className="bi bi-exclamation-triangle" aria-hidden="true" /> {etat.choisi} retiré de la liste
        </span>
      )}
    </label>
  );
}
